export const secondSnapshot = {
  date: "2025-12-28",
  description: "Interactive",
  hash: "7de4557",

  hero: {
    name: "Sebastian Wu",
    subtitle: "Grade 11 IB Student @ MHS",
    status: "Available for Opportunities"
  },

  aboutSections: [
    {
      title: "Who I Am",
      content: "Gr 11 IB student @ MHS"
    },
    {
      title: "Interests",
      content: "Math, problems solving, photography, coding, speedcubing, studio ghibli"
    },
    {
      title: "Currently",
      content: "Learning React, taking photos, working on personal projects"
    }
  ],

  skills: [
    {
      name: "Python",
      level: "Proficiebnt"
    },
    {
      name: "React",
      level: "Proficient"
    },
    {
      name: "HTML",
      level: "Proficient"
    },
    {
      name: "CSS",
      level: "Intermediate"
    },
    {
      name: "Javascript",
      level: "Proficient"
    },
  ],

  features: {
    photography: true,
    cubing: false,
    guestbook: false,
    blog: false,
    navigation: false,
    konami: true,
    timeTravel: true,
    music: true,
    weather: true,
    clock: true,
    resume: false, 
  },

  styling: {
    hasBackgroundImage: true,
    cardOpacity: 0.8,
    borderRadius: "24px"
  }
};